module.exports = __webpack_public_path__ + "62351af71d83393d848f6d99893dd94b.svg";